module.exports = __webpack_public_path__ + "static/media/react1Archi.47b8290a.png";